import store from '@/store'
import showCurrentApp from '@/utils/showCurrentApp.js'
import { createMicroApp } from '@/config/microAppConfig.js'
import Vue from 'vue'
import UrlParse from 'url-parse'

export function openLink(page) {
  const endUrl = page.pageUrl
  let microAppUrl
  const isMicroApp = store.state.appsInOrg.find(
    (app) => app.appName === page.applicationName && app.microFrontFlag === '1'
  )
  if (isMicroApp && page.type === 'toMicroApp') {
    const endUrlObj = new UrlParse(endUrl, true)
    microAppUrl = '/' + page.applicationName + endUrlObj.pathname
    console.log(endUrlObj, page, 'endUrlObj')
  }
  createMicroApp({
    ...page,
    pageUrl: isMicroApp ? microAppUrl : page.pageUrl,
  }).then(async (res) => {
    await Vue.prototype.$tabs.openTab({
      title: page.pageTitle,
      titleParent: ['子应用', '跳转', page.applicationName],
      path: isMicroApp ? microAppUrl : page.pageUrl,
      query: {},
    })
    Vue.prototype.$nextTick(() => {
      showCurrentApp()
    })
  })
}
